import { render, staticRenderFns } from "./classEventDetails.vue?vue&type=template&id=324e4b4a&"
import script from "./classEventDetails.vue?vue&type=script&lang=js&"
export * from "./classEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./classEventDetails.vue?vue&type=style&index=0&id=324e4b4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports